import React, { useState, useContext, useEffect, useRef } from "react";
import "./AddNotes.css";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
} from "@material-ui/core";
import { TextField } from "@material-ui/core";
import {
  getNotesData,
  getEntityList,
  getGstinByEntity,
  setDefaultEntity,
  setSelectedGstin,
  setSelectedPeriods,
  setProfileData,
  downloadNotesExcel,
  setOpenAddNotes,
  getUserModules,
  createNoteWithFiles,
} from "../Notes/action";
import { useDispatch, useSelector } from "react-redux";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import GTLabel from "components/GTLabel";
import SingleSelect from "components/Select/SingleSelect";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
// import UserContext from "../Context/UserContext";
import "../Notes/style.css";
import RenderDatePicker from "../Notes/RenderDatePicker";
import Upload from "./Upload";
import { errorToastMessage } from "utils/errorToast";
import { COMMON_MSGS } from "Constant/Messages";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";

const useStyles = makeStyles(() => ({
  selectRoot: {
    // size & look of the control
    minWidth: 220,
  },
  icon: {
    color: "#2B144D", // 🔥 your dark purple brand color
    right: 32,
    position: "absolute",
    pointerEvents: "none",
    zIndex: 1400,
  },
  menuPaper: {
    borderRadius: 12,
    maxHeight: 200,
  },
  placeholder: {
    color: "#8A8890", // soft grey for placeholder text
  },
}));

const PillInput = withStyles({
  input: {
    borderRadius: 12,
    width: 150, // ⬅️ control width
    height: 20,
    position: "relative",
    backgroundColor: "#FFFFFF",
    fontSize: 14,
    padding: "12px 40px 12px 16px", // right padding for the icon
    boxShadow: "0 1px 0 rgba(0,0,0,0.06) inset",
    border: "1px solid rgba(0,0,0,0.06)",
    "&:focus": {
      borderRadius: 12,
      borderColor: "#A06DFF", // brand bright purple focus
      boxShadow: "white",
      backgroundColor: "#FFFFFF",
    },
  },
})(InputBase);

// Entity Select Component
function EntitySelect({ entityMasterList, defaultEntity, handleEntity }) {
  const classes = useStyles();

  // Get formatted entity master list
  const getEntityMasterList = () => {
    return entityMasterList?.map((item) => {
      if (item?.value && defaultEntity)
        item.checked = item.value === defaultEntity;
      return item;
    });
  };

  // helper to show label by value
  const getLabel = (val) => {
    const entityList = getEntityMasterList();
    return (
      entityList?.find((e) => String(e.value) === String(val))?.label ?? ""
    );
  };

  return (
    <FormControl className={classes.selectRoot}>
      <Select
        value={defaultEntity || ""}
        onChange={(e) => handleEntity(e.target.value)}
        input={<PillInput />}
        IconComponent={KeyboardArrowDownIcon}
        classes={{ icon: classes.icon }}
        displayEmpty
        renderValue={(selected) => {
          if (selected === "" || selected === undefined || selected === null) {
            return <span className={classes.placeholder}>Select Entity</span>;
          }
          return getLabel(selected);
        }}
        MenuProps={{
          classes: { paper: classes.menuPaper },
          getContentAnchorEl: null, // better menu positioning in v4
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
      >
        <MenuItem value="">
          <em>Select Entity</em>
        </MenuItem>
        {getEntityMasterList()?.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

// Module Select Component
function ModuleSelect({ module, setModule, moduleData, getFilteredModules }) {
  const classes = useStyles();

  const filteredModules = getFilteredModules(moduleData);

  // helper to show label by id
  const getLabel = (val) => {
    const selectedModule = filteredModules?.find((m) => String(m.moduleId) === String(val));
    return selectedModule?.displayName || selectedModule?.module_name || "";
  };

  return (
    <FormControl className={classes.selectRoot}>
      <Select
        value={module}
        onChange={(e) => setModule(e.target.value)}
        input={<PillInput />}
        IconComponent={KeyboardArrowDownIcon}
        classes={{ icon: classes.icon }}
        displayEmpty
        renderValue={(selected) => {
          if (selected === "" || selected === undefined || selected === null) {
            return <span className={classes.placeholder}>Select Module</span>;
          }
          return getLabel(selected);
        }}
        MenuProps={{
          classes: { paper: classes.menuPaper },
          getContentAnchorEl: null, // better menu positioning in v4
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
      >
        <MenuItem value="">
          <em>Select Module</em>
        </MenuItem>
        {filteredModules?.map((moduleItem) => (
          <MenuItem key={moduleItem.moduleId} value={moduleItem.moduleId}>
            {moduleItem.displayName || moduleItem.module_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

// Category Select Component
function CategorySelect({ category, setCategory }) {
  const classes = useStyles();

  const categoryOptions = [
    { value: "working_file", label: "Working File" },
    { value: "filed_return", label: "Filed Return" },
  ];

  const getLabel = (val) =>
    categoryOptions.find((c) => c.value === val)?.label ?? "";

  return (
    <FormControl className={classes.selectRoot}>
      <Select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        input={<PillInput />}
        IconComponent={KeyboardArrowDownIcon}
        classes={{ icon: classes.icon }}
        displayEmpty
        renderValue={(selected) => {
          if (selected === "" || selected === undefined || selected === null) {
            return <span className={classes.placeholder}>Select Category</span>;
          }
          return getLabel(selected);
        }}
        MenuProps={{
          classes: { paper: classes.menuPaper },
          getContentAnchorEl: null, // better menu positioning in v4
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
      >
        <MenuItem value="">
          <em>Select Category</em>
        </MenuItem>
        {categoryOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

// GSTIN Select Component
function GstinSelect({ profileData, storeSelectedGstin, handleGstin }) {
  const classes = useStyles();

  // Get formatted GSTIN list
  const getGstinList = () => {
    return (
      profileData?.map((item) => ({
        value: item.gstin || item.GSTIN,
        label: item.gstin || item.GSTIN,
      })) || []
    );
  };

  // helper to show label by value
  const getLabel = (val) => {
    const gstinList = getGstinList();
    return gstinList?.find((g) => g.value === val)?.label ?? "";
  };

  // Get current selected GSTIN (first one from array)
  const selectedGstin =
    storeSelectedGstin && storeSelectedGstin.length > 0
      ? storeSelectedGstin[0]
      : "";

  return (
    <FormControl className={classes.selectRoot}>
      <Select
        value={selectedGstin || ""}
        onChange={(e) => {
          const selectedValue = e.target.value;
          // Create mock selectedNodes format for compatibility with existing handleGstin
          const selectedNodes = selectedValue
            ? [{ gstin: selectedValue, GSTIN: selectedValue }]
            : [];
          handleGstin(null, selectedNodes);
        }}
        input={<PillInput />}
        IconComponent={KeyboardArrowDownIcon}
        classes={{ icon: classes.icon }}
        displayEmpty
        renderValue={(selected) => {
          if (selected === "" || selected === undefined || selected === null) {
            return <span className={classes.placeholder}>Select GSTIN</span>;
          }
          return getLabel(selected);
        }}
        MenuProps={{
          classes: { paper: classes.menuPaper },
          getContentAnchorEl: null, // better menu positioning in v4
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
      >
        <MenuItem value="">
          <em>Select GSTIN</em>
        </MenuItem>
        {getGstinList()?.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

// Add the module mapping constant at the top of the component
const moduleMapping = {
  1: "E-INV", // E-INV
  2: "E-WB",
  3: "gstr1New", // GSTR-1
  4: "gstr2a2bNew", // GSTR-2A/2B
  5: "gstr3b", // GSTR-3B
  // 6: "Data Analytics",
  7: "Data Fetch",
  8: "gstr9_new", // GSTR-9 (first occurrence)
  9: "Analytics",
  11: "gstr7", // GSTR-7
  12: "itc04", // ITC-04
  13: "gstr6", // GSTR-6
  14: "gstr2X", // GSTR-2X
  15: "gstr8", // GSTR-8
  16: "GtaxPro Tutorials",
  17: "imsReco", // IMS
  18: "EWB-Reco",
};

export default function AddNotes(props) {
  const dispatch = useDispatch();
  const [module, setModule] = useState("");
  const [category, setCategory] = useState("");

  const [profile, setProfile] = useState([]);
  const [gstinList, setGstinList] = useState([]);

  const [note, setNote] = useState("");
  // const [heading, setHeading] = useState("");

  const {
    loaderStatus,
    tableData,
    entityMasterList,
    defaultEntity,
    profileData,
    selectedGstin: storeSelectedGstin,
    selectedPeriods,
    selectedRowNotes,
    selectedModule: storeSelectedModule,
    selectedCategory: storeSelectedCategory,
    search: storeSearch,
  } = useSelector((store) => store.notesReducer);

  const { openAddNotes, moduleIds } = useSelector(
    (state) => state.notesReducer
  );

  const handleCloseAddNotes = () => {
    dispatch(setOpenAddNotes(false));
  };

  // Function to filter allowed modules
  const getFilteredModules = (moduleData) => {
    const excludedModuleIds = [1, 2, 6, 7, 9, 16, 18];
    return moduleData?.filter(moduleItem => 
      !excludedModuleIds.includes(moduleItem.moduleId) && 
      moduleItem.module_name // Also filter out modules without names
    ).map(moduleItem => {
      let displayLabel = moduleItem.module_name;
      
      // Custom label mapping
      if (moduleItem.module_name === "GSTR-9") {
        displayLabel = "GSTR-9/9C";
      } else if (moduleItem.module_name === "IMS") {
        displayLabel = "IMS Reco";
      }
      
      return {
        ...moduleItem,
        displayName: displayLabel
      };
    }) || [];
  };

  // Get formatted entity master list
  const getEntityMasterList = () => {
    return entityMasterList?.map((item) => {
      if (item?.value && defaultEntity)
        item.checked = item.value === defaultEntity;
      return item;
    });
  };
  const handleEntity = async (value) => {
    try {
      dispatch(setDefaultEntity(value || ""));

      if (value) {
        const profiles = await dispatch(getGstinByEntity(value));
        const newProfile =
          profiles?.length > 0
            ? profiles.map((v) => ({
                ...v,
                label: v.gstin,
                value: v.gstin,
                checked:
                  v.gstin === storeSelectedGstin?.[0] && v.gstin !== ""
                    ? true
                    : false,
              }))
            : [];

        setGstinList(newProfile);

        // Clear GSTIN selection when entity changes
        dispatch(setSelectedGstin([]));
      } else {
        await dispatch(setProfileData([]));
        dispatch(setSelectedGstin([]));
        setGstinList([]);
      }
    } catch (error) {
      console.log("Error in handleEntity:", error);
    }
  };

  const handleGstin = async (currentNode, selectedNodes) => {
    // Handle single GSTIN selection from Container component
    let gstin =
      selectedNodes.length > 0
        ? selectedNodes[0].gstin || selectedNodes[0].value
        : "";
    dispatch(setSelectedGstin(gstin ? [gstin] : []));
  };
  const handlePeriodsChange = (periods) => {
    dispatch(setSelectedPeriods(periods));
    console.log("Selected periods:", periods);
  };
  useEffect(() => {
    // console.log("Module Data from props:", props.moduleData);
    // console.log("Module from props:", props.module);
    // console.log("moduleIds from Redux:", moduleIds);

    // Set default module if available
    if (props.module && moduleIds?.length > 0) {
      const defaultModuleId = getModuleIdFromString(props.module);
      const moduleExists = moduleIds.some(
        (m) => m.moduleId === defaultModuleId
      );

      if (defaultModuleId && moduleExists) {
        setModule(defaultModuleId);
      }
    }
  }, [props, moduleIds]);

  // Initialize profile data structure
  useEffect(() => {
    let newProfile =
      profileData?.length > 0
        ? profileData.map((v) => ({ ...v, label: v.gstin, value: v.gstin }))
        : [];

    const AllProfile = [
      {
        label: "All GSTIN",
        value: "All GSTIN",
        checked: newProfile.length > 0,
        tagClassName: "special",
        children: newProfile,
      },
    ];
    setProfile(AllProfile);
  }, [profileData]);

  // Function to get GSTIN list for selected entity
  const getGstinList = async () => {
    if (defaultEntity) {
      let profiles = await dispatch(getGstinByEntity(defaultEntity));
      let newProfile =
        profiles?.length > 0
          ? profiles.map((v) => ({
              ...v,
              label: v.gstin,
              value: v.gstin,
              checked:
                v.gstin === storeSelectedGstin?.[0] && v.gstin !== ""
                  ? true
                  : false,
            }))
          : [];
      setGstinList(newProfile);
    }
  };

  // Load entity list on component mount
  useEffect(() => {
    dispatch(getEntityList());
  }, []);

  useEffect(() => {
    dispatch(getUserModules());
  }, []);

  // Load GSTIN list when component mounts and entity is already selected
  useEffect(() => {
    getGstinList();
  }, [defaultEntity]);

  // Function to get moduleId from module string
  const getModuleIdFromString = (moduleString) => {
    // Find the key (moduleId) where the value matches the moduleString
    const moduleId = Object.keys(moduleMapping).find(
      (key) => moduleMapping[key] === moduleString
    );
    return moduleId ? parseInt(moduleId) : null;
  };

  // Set default module when component mounts or props.module changes
  useEffect(() => {
    if (props.module && moduleIds?.length > 0) {
      const defaultModuleId = getModuleIdFromString(props.module);
      console.log("Default module from props:", props.module);
      console.log("Mapped module ID:", defaultModuleId);

      // Check if the mapped moduleId exists in the available moduleIds
      const moduleExists = moduleIds.some(
        (m) => m.moduleId === defaultModuleId
      );

      if (defaultModuleId && moduleExists) {
        setModule(defaultModuleId);
        console.log("Set default module to:", defaultModuleId);
      } else {
        console.log("Module not found in available modules or mapping failed");
      }
    }
  }, [props.module, moduleIds]);

  const classes = useStyles();
  const [filesData, setFilesData] = useState([]);
  const fileInputRef = useRef(null);

  // Add this helper function after the handleFileUpload function
  const getTotalFileSize = () => {
    const totalBytes = filesData.reduce((total, file) => {
      return total + (file.file ? file.file.size : 0);
    }, 0);

    const totalMB = (totalBytes / (1024 * 1024)).toFixed(2);
    return { bytes: totalBytes, mb: totalMB };
  };

  // Add this function to format file size for display
  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };
  // const handleFileUpload = (event) => {
  //   const selectedFiles = event.target.files;
  //   if (!selectedFiles) return;

  //   const newFiles = Array.from(selectedFiles).map((file) => ({
  //     FILE_ID: `${Date.now()}_${file.name}`,
  //     ORIGINAL_FILE_NAME: file.name,
  //     file: file, // Store the actual File object for API
  //     progress: 100, // static for now
  //   }));

  //   setFilesData((prev) => [...prev, ...newFiles]);
  // };
  // const handleFileUpload = (event) => {
  //   const selectedFiles = event.target.files;
  //   if (!selectedFiles) return;

  //   const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB in bytes

  //   // Calculate current total size of existing files
  //   const currentTotalSize = filesData.reduce((total, file) => {
  //     return total + (file.file ? file.file.size : 0);
  //   }, 0);

  //   // Calculate size of new files being added
  //   const newFilesSize = Array.from(selectedFiles).reduce((total, file) => {
  //     return total + file.size;
  //   }, 0);

  //   // Check if total size would exceed limit
  //   const totalSize = currentTotalSize + newFilesSize;

  //   if (totalSize > MAX_TOTAL_SIZE) {
  //     const totalSizeMB = (totalSize / (1024 * 1024)).toFixed(2);
  //     errorToastMessage(
  //       `Total file size (${totalSizeMB}MB) exceeds the 50MB limit. Please remove some files or select smaller files.`
  //     );

  //     // Clear the file input
  //     if (fileInputRef.current) {
  //       fileInputRef.current.value = "";
  //     }
  //     return;
  //   }

  //   const newFiles = Array.from(selectedFiles).map((file) => ({
  //     FILE_ID: `${Date.now()}_${file.name}`,
  //     ORIGINAL_FILE_NAME: file.name,
  //     file: file, // Store the actual File object for API
  //     progress: 100, // static for now
  //     size: file.size, // Store file size for display
  //   }));

  //   setFilesData((prev) => [...prev, ...newFiles]);

  //   // Clear the file input after successful upload
  //   if (fileInputRef.current) {
  //     fileInputRef.current.value = "";
  //   }
  // };

  const handleFileUpload = (event) => {
  const selectedFiles = event.target.files;
  if (!selectedFiles) return;

  // If category is 'filed_return', only allow PDF files
  if (category === "filed_return") {
    const hasInvalid = Array.from(selectedFiles).some((file) => {
      const fname = (file.name || "").toLowerCase();
      const isPdfExt = fname.endsWith(".pdf");
      const isPdfType = file.type === "application/pdf";
      return !(isPdfExt || isPdfType);
    });

    if (hasInvalid) {
      errorToastMessage(
        "In case of Filed Return, only PDF files are allowed to upload."
      );
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }
  }

  const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB in bytes

  // Calculate current total size of existing files
  const currentTotalSize = filesData.reduce((total, file) => {
    return total + (file.file ? file.file.size : 0);
  }, 0);

  // Calculate size of new files being added
  const newFilesSize = Array.from(selectedFiles).reduce((total, file) => {
    return total + file.size;
  }, 0);

  // Check if total size would exceed limit
  const totalSize = currentTotalSize + newFilesSize;

  if (totalSize > MAX_TOTAL_SIZE) {
    const totalSizeMB = (totalSize / (1024 * 1024)).toFixed(2);
    errorToastMessage(
      `Total file size (${totalSizeMB}MB) exceeds the 50MB limit. Please remove some files or select smaller files.`
    );

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    return;
  }

  // ***** NEW VALIDATION: File name max 20 characters *****
  for (let file of selectedFiles) {
    const nameWithoutExt =
      file.name.substring(0, file.name.lastIndexOf(".")) || file.name;

    if (nameWithoutExt.length > 50) {
      errorToastMessage(
        `Filename "${file.name}" is too long. Max 20 characters allowed.`
      );

      // Clear input & stop further processing
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }
  }
  // ********************************************************

  const newFiles = Array.from(selectedFiles).map((file) => ({
    FILE_ID: `${Date.now()}_${file.name}`,
    ORIGINAL_FILE_NAME: file.name,
    file: file,
    progress: 100,
    size: file.size,
  }));

  setFilesData((prev) => [...prev, ...newFiles]);

  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};

  const handleDelete = (fileId) => {
    setFilesData((prev) => prev.filter((f) => f.FILE_ID !== fileId));
  };
  const triggerFileInput = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };
  // Add the financial year validation function
  const isInSameFinancialYear = (monthsArray) => {
    // Check if monthsArray exists and is an array with at least one element
    if (
      !monthsArray ||
      !Array.isArray(monthsArray) ||
      monthsArray.length === 0
    ) {
      return false;
    }

    // Define the start month of the financial year
    const startMonth = 4; // April

    // Extract the year and month from the first element of the array
    const firstMonthData = monthsArray[0]?.split("-");
    if (!firstMonthData || firstMonthData.length !== 2) {
      return false;
    }

    const [firstMonth, firstYear] = firstMonthData.map(Number);

    // Check if parsing was successful
    if (isNaN(firstMonth) || isNaN(firstYear)) {
      return false;
    }

    // Calculate the financial year based on the start month
    const financialYear =
      firstMonth >= startMonth
        ? `${firstYear}-${firstYear + 1}`
        : `${firstYear - 1}-${firstYear}`;

    // Check if all months in the array belong to the same financial year
    for (const month of monthsArray) {
      if (!month || typeof month !== "string") {
        return false;
      }

      const monthData = month.split("-");
      if (monthData.length !== 2) {
        return false;
      }

      const [m, y] = monthData.map(Number);
      if (isNaN(m) || isNaN(y)) {
        return false;
      }

      if (
        !(
          (m >= startMonth && `${y}-${y + 1}` === financialYear) ||
          (m < startMonth && `${y - 1}-${y}` === financialYear)
        )
      ) {
        return false;
      }
    }
    return true;
  };

  // Add this helper function after the isInSameFinancialYear function
  const getPlainTextFromHTML = (htmlString) => {
    // Using DOMParser (most accurate for ReactQuill HTML)
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent || doc.body.innerText || "";
  };

  const handleSave = async () => {
    try {
      if (
        !defaultEntity ||
        !storeSelectedGstin ||
        storeSelectedGstin.length === 0 ||
        !module ||
        !category ||
        !selectedPeriods ||
        selectedPeriods.length === 0
      ) {
        errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
        return;
      }

      // if (!note || note.trim() === "") {
      //   errorToastMessage("Please enter note content");
      //   return;
      // }
      // Extract plain text from HTML and validate length
      const plainTextContent = getPlainTextFromHTML(note);
      const trimmedPlainText = plainTextContent.trim();
      const plainTextLength = trimmedPlainText.length;

      // if (!trimmedPlainText || plainTextLength === 0) {
      //   errorToastMessage("Please enter note content");
      //   return;
      // }

      // Add maximum length validation - 2000 characters
      if (plainTextLength > 2000) {
        errorToastMessage(
          `Note content cannot exceed 2000 characters. Current length: ${plainTextLength} characters.`
        );
        return;
      }
      if (!filesData || filesData.length === 0) {
        errorToastMessage("Please select at least one file");
        return;
      }
      // Add financial year validation
      if (!isInSameFinancialYear(selectedPeriods)) {
        errorToastMessage(
          "All selected periods must be within the same financial year"
        );
        return;
      }
      // Get module name from moduleIds array
      const selectedModuleData = moduleIds?.find((m) => m.moduleId === module);
      const moduleName = selectedModuleData?.module_name || "";
      console.log("Selected module name:", moduleName);

      // Get entity name from entityMasterList array
      const selectedEntityData = entityMasterList?.find(
        (e) => e.value === defaultEntity
      );
      const entityName = selectedEntityData?.label || "";
      console.log("Selected entity name:", entityName);

      // Prepare note data
      const noteData = {
        moduleCode: module,
        category: category,
        entityId: defaultEntity,
        entityName: entityName,
        heading: note, // Using note content as heading for now
        gstin:
          storeSelectedGstin && storeSelectedGstin.length > 0
            ? storeSelectedGstin[0]
            : "", // Single GSTIN selection
        periods: selectedPeriods,
        moduleName: moduleName,
      };

      console.log("Saving note with data:", noteData);
      console.log("Files to upload:", filesData);

      // Extract actual File objects from filesData
      const fileObjects = filesData.map((fileData) => fileData.file);

      // Call the API to create note with files
      const result = await dispatch(createNoteWithFiles(noteData, fileObjects));

      if (result) {
        // Close the dialog on successful save
        dispatch(setOpenAddNotes(false));

        // Refresh the notes data with current filters
        const currentFilters = {
          page: 1,
          module: storeSelectedModule || "",
          category: storeSelectedCategory || "",
          entity: defaultEntity,
          gstin: storeSelectedGstin[0] || "",
          search: storeSearch || "",
        };
        // dispatch(getNotesData(currentFilters));

        // Clear the form data
        setNote("");
        setFilesData([]);
        setModule("");
        setCategory("");
        dispatch(setDefaultEntity(""));
        dispatch(setSelectedGstin([]));
        dispatch(setSelectedPeriods([]));
        dispatch(setProfileData([]));
        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        console.log("Note saved successfully:", result);
      }
    } catch (error) {
      console.log("Error in handleSave:", error);
    }
  };
  // Clear selections on component unmount
  useEffect(() => {
    return () => {
      console.log("Add Notes component unmount");
      dispatch(setDefaultEntity(""));
      dispatch(setSelectedGstin([]));
      dispatch(setSelectedPeriods([]));
      dispatch(setProfileData([]));
      setNote("");
      setCategory("");
      setFilesData([]);
      handleCloseAddNotes();
    };
  }, []);
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
      />
      <div className="sweet-loading">
        <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
      </div>
      <Dialog
        open={openAddNotes}
        onClose={handleCloseAddNotes}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {/* Add Notes
          <IconButton
            aria-label="close"
            onClick={handleCloseAddNotes}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div></div>
            <Typography
              variant="h6"
              style={{
                textWrap: "wrap",
                wordBreak: "break-word",
                fontWeight: "bold",
              }}
            >
              Add Notes
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseAddNotes}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{ backgroundColor: "#f9f5ff" }}>
          <div
          // className="popup-content"
          >
            <div
              // className="r1"
              style={{ display: "flex" }}
            >
              <div
              // className="dd"
              >
                <GTLabel title={"Select Module"} />
                <ModuleSelect
                  module={module}
                  setModule={setModule}
                  moduleData={moduleIds} // Use moduleIds from Redux instead of props.moduleData
                  getFilteredModules={getFilteredModules}
                />
              </div>
              <div
              // className="dropdown"
              >
                <GTLabel title={"Select Category *"} />
                <CategorySelect category={category} setCategory={setCategory} />
              </div>

              <div
              // className="dropdown"
              >
                <GTLabel title={"Select Entity Name *"} />
                <EntitySelect
                  entityMasterList={entityMasterList}
                  defaultEntity={defaultEntity}
                  handleEntity={handleEntity}
                />
              </div>

              {/* <div
            // className="dropdown"
            >
              <GTLabel title={"Select GSTIN *"} />
              <GstinSelect
                profileData={profileData}
                storeSelectedGstin={storeSelectedGstin}
                handleGstin={handleGstin}
              />
            </div> */}

              {/* Commented out old Container component */}
              <div
                className="dropdown-container-notes"
                style={{
                  // marginLeft: "10px",
                  // marginRight: "10px",
                  width: "26%",
                  zIndex: 5,
                }}
              >
                <GTLabel title={"Select GSTIN *"} />
                <Container
                  data={gstinList}
                  mode="simpleSelect"
                  onChange={handleGstin}
                />
              </div>
            </div>
            <div
              // className="r2"
              style={{
                display: "flex",
                // alignItems: "baseline",
                gap: 16,
                // marginTop: 16,
              }}
            >
              <div
                style={{
                  marginLeft: "10px",
                  marginRight: "10px",
                  marginTop: "5px",
                }}
                id="notes-datepicker-addNotes"
              >
                <RenderDatePicker onPeriodsChange={handlePeriodsChange} />
              </div>
              <Button
                onClick={handleSave}
                variant="contained"
                color="primary"
                style={{
                  backgroundColor: "#4f2d7f",
                  color: "white",
                  textTransform: "capitalize",
                  height: "30px",
                  marginLeft: "4.6em",
                  paddingLeft: "4em",
                  paddingRight: "4em",
                  marginTop: "2.5em",
                  fontSize: "12px",
                }}
              >
                Save
              </Button>

              <input
                type="file"
                multiple
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileUpload}
                accept={category === "filed_return" ? ".pdf" : ".pdf,.xlsx,.xls,.docx,.txt,.csv,.jpg,.png"}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={triggerFileInput}
                style={{
                  backgroundColor: "#4f2d7f",
                  color: "white",
                  textTransform: "capitalize",
                  height: "30px",
                  paddingLeft: "3em",
                  paddingRight: "3em",
                  marginTop: "2.5em",
                  fontSize: "12px",
                }}
              >
                Upload
              </Button>
              {filesData.length > 0 && (
                <div
                  style={{
                    fontSize: "12px",
                    marginTop: "20px",
                    color:
                      getTotalFileSize().bytes > 40 * 1024 * 1024
                        ? "#ff6b6b"
                        : "#666",
                    marginLeft: "10px",
                  }}
                >
                  Total: {getTotalFileSize().mb}MB / 50MB
                </div>
              )}
            </div>

            <div className="r3" style={{ marginTop: 16 }}>
              <div
                className="text-area"
                style={{
                  width: "100%",
                  marginLeft: -5,
                  padding: 5,
                  borderRadius: 10,
                }}
              >
                <ReactQuill
                  value={note}
                  onChange={setNote}
                  theme="snow"
                  style={{ height: "200px", marginBottom: "20px" }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, 3, false] }],
                      ["bold", "italic", "underline"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["clean"],
                    ],
                  }}
                />
              </div>
            </div>

            <Upload filesData={filesData} handleDelete={handleDelete} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
